// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"647":"remote-client_access-session","794":"remote-client_session"}[chunkId] + "." + {"647":"583ff006","794":"cbfff516"}[chunkId] + ".css";
};